<script>
import { mapActions, mapGetters } from "vuex";
// import Multiselect from "vue-multiselect";
import { required, requiredIf, email } from "vuelidate/lib/validators";
import moment from "moment";
import AddLocationModal from "@/components/sites/AddLocationModal";
import LocationPolicyModal from "@/components/sites/LocationPolicyModal";

export default {
  name: "SiteActionForm",
  components: { AddLocationModal, LocationPolicyModal },
  data() {
    return {
      siteInfoLength: null,
      siteId: null,
      // timezone: null,
      form: {
        site: {
          name: "",
          reception_email: "",
          entity_id: "",
          timezone: "",
          location: "",
          is_geofencing_enabled: 0,
        },
      },
      timezoneObject: null,
      submitted: false,
      areas_count: 0,
    };
  },
  validations: {
    form: {
      site: {
        reception_email: { required, email },
        name: { required },
        timezone: { required },
        location: {
          required: requiredIf(function () {
            return this.form.site.is_geofencing_enabled;
          }),
        },
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("sites", [
      "getRadius",
      "getLat",
      "getLong",
      "getLocationName",
      "getZoom",
    ]),
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("addSite_");
    },
    getLocationName(val) {
      this.form.site.location = val;
    },
    form: {
      handler: function (value) {
        console.log("form changed: ", value);
        if (!this.originalGeoFencing && value.site.is_geofencing_enabled)
          this.$bvModal.show("locationPolicyConfirmModal");
        this.originalGeoFencing = this.form.site.is_geofencing_enabled;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("sites", ["setLocationName"]),
    reverseGeocode(lat, lng) {
      return new Promise((resolve, reject) => {
        fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
        )
          .then((response) => response.json())
          .then((data) => {
            const locationName = data.name ? data.name : data.display_name;
            resolve(locationName);
            console.log("locccc", locationName);
            this.setLocationName(locationName);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.submitted = true;
      const form = this.form;
      if (form.site.is_geofencing_enabled) {
        form.site.locations = [
          {
            shape: "circle",
            coordinates: [
              {
                lat: this.getLat,
                long: this.getLong,
                radius: this.getRadius,
                zoom: this.getZoom,
              },
            ],
          },
        ];
      }
      this.siteInfoLength
        ? this.$emit("updateSite", {
            id: this.siteId,
            params: form.site,
          })
        : this.$emit("createNewSite", {
            params: form.site,
          });
    },
  },
  beforeMount() {
    this.setLocationName("");
    this.areas_count = this.getModalInfo?.areas_count;
    this.timezoneObject = moment.tz.names();
    // set site data
    this.form.site.entity_id = this.currentEntity.id;
    this.siteInfoLength =
      this.getModalInfo && Object.keys(this.getModalInfo).length > 0;
    this.originalGeoFencing = false;
    if (this.getModalInfo && Object.keys(this.getModalInfo).length > 0) {
      const { id, name, timezone, reception_email, is_geofencing_enabled } =
        this.getModalInfo;
      this.form.site.name = name;
      this.form.site.reception_email = reception_email;
      this.siteId = id;
      timezone && (this.form.site.timezone = timezone);
      this.form.site.is_geofencing_enabled = is_geofencing_enabled === 1;
      this.originalGeoFencing = this.form.site.is_geofencing_enabled;

      if (this.form.site.is_geofencing_enabled) {
        this.$store.commit(
          "sites/setRadius",
          this.getModalInfo.locations[0].coordinates[0].radius
        );
        this.$store.commit(
          "sites/setLat",
          this.getModalInfo.locations[0].coordinates[0].lat
        );
        this.$store.commit(
          "sites/setLong",
          this.getModalInfo.locations[0].coordinates[0].long
        );
        this.$store.commit(
          "sites/setZoom",
          this.getModalInfo.locations[0].coordinates[0].zoom
        );
        this.reverseGeocode(
          this.getModalInfo.locations[0].coordinates[0].lat,
          this.getModalInfo.locations[0].coordinates[0].long
        );
      } else {
        this.$store.commit("sites/setRadius", null);
        this.$store.commit("sites/setLat", null);
        this.$store.commit("sites/setLong", null);
        this.$store.commit("sites/setZoom", null);
      }
    } else {
      this.$store.commit("sites/setRadius", null);
      this.$store.commit("sites/setLat", null);
      this.$store.commit("sites/setLong", null);
      this.$store.commit("sites/setZoom", null);
    }
  },
};
</script>

<template>
  <div class="site-action-form">
    <b-modal id="addLocation" hide-footer hide-header size="xl" scrollable>
      <AddLocationModal
        :timezone="form.site.timezone"
        :isEdit="!!siteInfoLength"
      />
    </b-modal>

    <b-modal
      id="locationPolicyConfirmModal"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-esc
      no-close-on-backdrop
    >
      <LocationPolicyModal />
    </b-modal>
    <h4 class="allareakiosk-header">
      {{
        siteInfoLength > 0
          ? $t("sitesAndDevices.siteActions.editSite")
          : $t("sitesAndDevices.addSite")
      }}
    </h4>
    <p
      v-if="!areas_count"
      class="vp-width-415 text-center vp-mb-24 vp-color-grey-2 vp-font-size-16"
    >
      {{ $t("sitesAndDevices.notes.addArea") }}.
    </p>
    <div class="form-groups site-addedit">
      <!-- name   -->
      <b-form-group class="site-name" id="siteName">
        <vp-input
          v-model="$v.form.site.name.$model"
          :label="$t('common.siteName')"
          width="415"
          maxlength="50"
          :disabled="submitted"
        />
      </b-form-group>

      <!-- Email Reception Address  -->
      <b-form-group class="contact-email" id="email">
        <vp-input
          v-model="$v.form.site.reception_email.$model"
          :label="$t('common.contactEmail')"
          width="415"
          :disabled="submitted"
          :invalid="!$v.form.site.reception_email.email"
          errMsg="Invalid email format."
          :class="{ 'vp-mb-20': !$v.form.site.reception_email.email }"
        />
      </b-form-group>

      <!-- timezone  -->
      <b-form-group class="timezone-input" id="timezone">
        <vp-multiselect
          id="timezone"
          v-model="$v.form.site.timezone.$model"
          :title="$t('common.timezone')"
          :options="timezoneObject"
          :showLabels="false"
          :allowEmpty="true"
          :showPlaceholderIcon="true"
          dropDownStyle="relative"
          :showOptionsBorder="true"
          :disabled="submitted"
        />
      </b-form-group>

      <div
        class="line-customization"
        style="width: 416px; margin: 32px auto"
      ></div>
      <div class="d-flex align-items-center" style="margin-bottom: 32px">
        <p class="geo-text">{{ $t('sitesAndDevices.geofencing')}}</p>
        <div class="tool-con">
          <svg
            v-show="form.site.is_geofencing_enabled"
            tabindex="0"
            v-b-tooltip
            id="location-policy"
            width="17.7"
            height="17.7"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.86201 5.64211e-08C7.10912 0.000197833 5.39565 0.520172 3.93827 1.49417C2.48089 2.46817 1.34505 3.85245 0.674388 5.47197C0.00372177 7.09149 -0.171673 8.87351 0.170421 10.5927C0.512514 12.3119 1.35671 13.891 2.59626 15.1304C3.83582 16.3698 5.41506 17.2139 7.13429 17.5558C8.85351 17.8977 10.6355 17.7221 12.255 17.0512C13.8744 16.3804 15.2586 15.2444 16.2324 13.7869C17.2062 12.3294 17.726 10.6159 17.726 8.86299C17.726 7.699 17.4967 6.54641 17.0513 5.47104C16.6058 4.39567 15.9529 3.41857 15.1297 2.59555C14.3066 1.77253 13.3295 1.11971 12.254 0.674362C11.1786 0.229014 10.026 -0.000131275 8.86201 5.64211e-08ZM10.021 13.5C10.021 13.8074 9.89891 14.1022 9.68156 14.3195C9.4642 14.5369 9.1694 14.659 8.86201 14.659C8.55462 14.659 8.25982 14.5369 8.04246 14.3195C7.82511 14.1022 7.70301 13.8074 7.70301 13.5V8C7.70301 7.69261 7.82511 7.39781 8.04246 7.18045C8.25982 6.9631 8.55462 6.84099 8.86201 6.84099C9.1694 6.84099 9.4642 6.9631 9.68156 7.18045C9.89891 7.39781 10.021 7.69261 10.021 8V13.5ZM8.86201 5.388C8.63336 5.3874 8.41001 5.31913 8.2201 5.19179C8.0302 5.06445 7.88223 4.88374 7.79487 4.67244C7.70751 4.46114 7.68466 4.22871 7.7292 4.00444C7.77373 3.78017 7.88368 3.57412 8.04515 3.41223C8.20661 3.25035 8.41239 3.13987 8.63655 3.09476C8.8607 3.04964 9.09317 3.07191 9.3047 3.15872C9.51622 3.24554 9.69732 3.39302 9.82514 3.5826C9.95297 3.77217 10.0218 3.99536 10.023 4.224C10.0237 4.37674 9.9941 4.5281 9.93602 4.66937C9.87793 4.81064 9.79246 4.93902 9.68455 5.04712C9.57664 5.15522 9.4484 5.24091 9.30723 5.29924C9.16606 5.35757 9.01475 5.38739 8.86201 5.38699V5.388Z"
              fill="#787878"
            />
          </svg>
          <b-tooltip
            id="location-policy"
            placement="rightbottom"
            target="location-policy"
            triggers="click blur"
          >
            <ul>
              <li class="local-policy">{{ $t('sitesAndDevices.localPrivacy')}}</li>
              <li class="text">{{ $t('sitesAndDevices.localPrivacyNote')}}</li>
              <li class="line"></li>
              <li class="reminder">{{ $t('sitesAndDevices.signInReminder')}}</li>
              <li class="text">{{ $t('sitesAndDevices.proximityReminder')}}</li>
              <li class="text">{{ $t('sitesAndDevices.proximityReminderNote')}}</li>
            </ul>
          </b-tooltip>
        </div>
      </div>
      <div class="align-items-center d-flex allow-geofence">
        <p class="allow-geofence-text">{{ $t("sitesAndDevices.allowGeofencing") }}</p>
        <b-form-checkbox
          switch
          size="lg"
          class="switch-gray radio-updateArea"
          v-model="form.site.is_geofencing_enabled"
        ></b-form-checkbox>
      </div>

      <div v-if="form.site.is_geofencing_enabled" v-b-modal="'addLocation'">
        <div v-if="!form.site.location" class="outer-div">
          <div class="location-text">{{ $t('common.location') }}</div>
          <div v-if="form.site.location" class="label-text">{{ $t('common.location') }}</div>
          <svg
            class="location-display"
            width="17"
            height="21"
            viewBox="0 0 17 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.14638 0.00110501C8.1573 0.000552503 8.16821 0 8.17912 0V0.00442012C12.6365 0.0751421 16.2273 3.75268 16.2273 8.2811C16.2273 14.3853 9.15049 20.1779 8.11364 21C7.07678 20.1756 0 14.3831 0 8.2811C0 3.75268 3.59078 0.0751421 8.04815 0.00442012V0C8.05907 0 8.06998 0.000552515 8.08089 0.00110503C8.09181 0.00165754 8.10272 0.00221006 8.11364 0.00221006C8.12455 0.00221006 8.13547 0.00165753 8.14638 0.00110501ZM8.11435 10.4982C9.95948 10.4982 11.4553 9.00245 11.4553 7.15732C11.4553 5.31218 9.95948 3.81641 8.11435 3.81641C6.26921 3.81641 4.77344 5.31218 4.77344 7.15732C4.77344 9.00245 6.26921 10.4982 8.11435 10.4982Z"
              fill="#787878"
            />
          </svg>
        </div>

        <div v-else class="selected-location d-flex">
          <div class="selected-text">
            <div class="lcation-label">{{ $t('common.location') }}</div>
            <div class="selected-map-location">
              {{ form.site.location ? form.site.location :  $t('common.location') }}
            </div>
          </div>
          <div class="selected-icon">
            <svg
              width="17"
              height="21"
              viewBox="0 0 17 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.14638 0.00110501C8.1573 0.000552503 8.16821 0 8.17912 0V0.00442012C12.6365 0.0751421 16.2273 3.75268 16.2273 8.2811C16.2273 14.3853 9.15049 20.1779 8.11364 21C7.07678 20.1756 0 14.3831 0 8.2811C0 3.75268 3.59078 0.0751421 8.04815 0.00442012V0C8.05907 0 8.06998 0.000552515 8.08089 0.00110503C8.09181 0.00165754 8.10272 0.00221006 8.11364 0.00221006C8.12455 0.00221006 8.13547 0.00165753 8.14638 0.00110501ZM8.11435 10.4982C9.95948 10.4982 11.4553 9.00245 11.4553 7.15732C11.4553 5.31218 9.95948 3.81641 8.11435 3.81641C6.26921 3.81641 4.77344 5.31218 4.77344 7.15732C4.77344 9.00245 6.26921 10.4982 8.11435 10.4982Z"
                fill="#103F5E"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="vertical-line"></div>
    <div class="d-flex justify-content-center align-items-center allpopup-btns">
      <button
        :disabled="
          submitted ||
          $v.form.site.$invalid ||
          (siteInfoLength > 0 &&
            form.site.name === getModalInfo.name &&
            form.site.timezone === getModalInfo.timezone &&
            form.site.reception_email === getModalInfo.reception_email &&
            form.site.is_geofencing_enabled ==
              getModalInfo.is_geofencing_enabled &&
            ((getModalInfo.is_geofencing_enabled &&
              getLong === getModalInfo.locations[0].coordinates[0].long &&
              getLat === getModalInfo.locations[0].coordinates[0].lat &&
              getRadius === getModalInfo.locations[0].coordinates[0].radius) ||
              !getModalInfo.is_geofencing_enabled))
        "
        class="submit-btn btn btn-primary approval-btn"
        size="md"
        @click="onSubmit"
      >
        <i
          v-if="submitted"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        {{ siteInfoLength > 0 ? $t('common.edit') : $t('common.add') }}
      </button>
      <button
        class="btn btn-outline-danger cancellation-btn"
        :class="{ 'cursor-stop': submitted }"
        @click="$bvModal.hide('addSite_')"
        :disabled="submitted"
      >
        {{ $t('common.cancel' )}}
      </button>
    </div>
  </div>
</template>
<style lang="scss">
div#location-policy:focus {
  border: none !important;
  outline: none !important;
}
svg#location-policy:focus {
  border: none !important;
  outline: none !important;
}

.bs-tooltip-left .tooltip-inner{
  transform : translate3d(-200px, 0, 0);
}
div#location-policy.tooltip.b-tooltip.bs-tooltip-right ,div#location-policy.tooltip.b-tooltip.bs-tooltip-left{
  opacity: 1 !important;
  .arrow {
    display: none !important;
  }
  .tooltip.b-tooltip.bs-tooltip-right .arrow ,.tooltip.b-tooltip.bs-tooltip-left .arrow {
    display: none !important;
  }
  .bs-tooltip-right .arrow::before,.bs-tooltip-left .arrow::before {
    color: transparent !important;
    display: none !important;
    background-color: transparent !important;
    border-right-color: transparent !important;
  }
  .tooltip-inner {
    opacity: 1 !important;
    background: #ffffff !important;
    max-width: 240px !important;
    width: 240px !important;
    text-align: start !important;
    padding: 16px !important;
    margin-top: 100px !important;
    margin-inline-start: 25px !important;
    ul {
      margin-bottom: 0px !important;
      li.local-policy,
      li.reminder {
        font-weight: 700 !important;
        font-size: 12px !important;
        line-height: 14px !important;
        padding-bottom: 8px !important;
      }
      li.text {
        font-weight: 400 !important;
        font-size: 12px !important;
        line-height: 17px !important;
      }
      li.line {
        /* color: #707070; */
        border-bottom: solid #707070 1px;
        padding-top: 16px;
        margin-bottom: 16px;
        opacity: 0.15 !important;
        /* padding-bottom: 16px; */
      }
    }
  }
}
.cursor-stop {
  cursor: not-allowed;
}
:dir(rtl)
  div#addSite_
  .custom-control-input:checked
  ~ .custom-control-label:after {
  inset-inline-start: -5px !important;
}
:dir(ltr)
  div#addSite_
  .custom-control-input:checked
  ~ .custom-control-label:after {
  inset-inline-start: -34px !important;
}
div#addSite_ {
  p.allow-geofence-text {
    margin-bottom: 0px !important;
    color: var(--Grey-1, #787878);

    font-size: 16px;

    font-weight: 700;
    line-height: normal;
  }

  .allow-geofence {
    width: 416px;
    border-radius: 4px;
    background: #f2f2f2;
    height: 55px;
    margin-bottom: 16px;
    padding-inline-end: 20px;
    padding-inline-start: 20px;
    justify-content: space-between;
  }

  .switch-gray .custom-control-label::before {
    top: 6px !important;
    width: 43px !important;
    height: 21px !important;
    background: #d1d1d1 !important;
    border: none !important;
    border-radius: 13.5px;
  }

  .switch-gray.radio-updateArea .custom-control-label::after {
    top: 5px !important;
    inset-inline-start: -45px !important;
    background: #939393;
    width: 21px !important;
    height: 21px !important;
    border-radius: 100% !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }

  .switch-gray.radio-updateArea
    .custom-control-input:checked
    ~ .custom-control-label:before {
    position: absolute;
    top: 6px !important;
  }

  .switch-gray .custom-control-input:checked ~ .custom-control-label:before {
    position: absolute;
    top: 0px !important;
    width: 43px;
    height: 21px;
    background: #d1d1d1 !important;
    border: none !important;
    border-radius: 13.5px !important;
  }

  .switch-gray.radio-updateArea.custom-control.custom-switch.b-custom-control-lg {
    margin-top: -13px;
    margin-inline-end: -7px;

    .custom-control-input:checked ~ .custom-control-label:after {
      width: 21px !important;
      height: 21px !important;
      top: 6px !important;
      background-color: #34c38f;
    }
  }

  // background: red;
  div#addSite____BV_modal_content_ {
    width: 579px;

    border-radius: 26px;

    div#addSite____BV_modal_body_ {
      .multiselect__content-wrapper {
        max-height: 120px !important;
      }

      padding: 0px !important;
      .site-action-form {
        padding-top: 41px;
        padding-inline-end: 40px;
        padding-bottom: 0px;
        padding-inline-start: 40px;

        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 51px;
          margin-inline-start: 0px;
          text-align: center;
        }
        .form-group {
          margin-bottom: 14px;
        }

        .form-groups.site-addedit {
          width: 416px;
          input#siteName {
            width: 415px;
            height: 55px;
            background: #f2f2f2;
            border-radius: 4px;
            border: none;
            outline: none;

            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            position: relative;
            letter-spacing: 0.25px;
            color: rgba(0, 0, 0, 0.87);
            opacity: 0.8;
            padding-inline-start: 20px;
            transition: 0.6s !important;
            &::placeholder {
              font-weight: 400;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(96, 96, 96, 0.87);
            }

            &:focus::placeholder {
              font-weight: 700 !important;
              font-size: 12px !important;
              line-height: 17px !important;
              letter-spacing: 0.25px;
              z-index: 99999;
              color: #103f5e !important;
              transform: translate(0px, -19px);
            }
          }

          input#email {
            width: 415px;
            height: 55px;
            background: #f2f2f2;
            border-radius: 4px;
            border: none;
            outline: none;
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            position: relative;
            letter-spacing: 0.25px;
            color: rgba(0, 0, 0, 0.87);
            opacity: 0.8;
            padding-inline-start: 20px;
            transition: 0.6s !important;
            &::placeholder {
              z-index: 99999;
              font-weight: 400 !important;
              font-size: 16px !important;
              line-height: 17px !important;
              letter-spacing: 0.25px !important;
              color: rgba(96, 96, 96, 0.87) !important;
            }
            &:focus::placeholder {
              font-weight: 700 !important;
              font-size: 12px !important;
              line-height: 17px !important;
              letter-spacing: 0.25px !important;
              z-index: 99999;
              color: #103f5e !important;
              transform: translate(0px, -19px);
            }
          }

          input#timezone {
            background: #f2f2f2 !important;

            &::placeholder {
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(0, 0, 0, 0.87);
              opacity: 0.8;
            }
          }
        }

        .line-customization {
          height: 1px;
          opacity: 0.15;
          background: #707070;
          margin: 40px auto 20px auto !important;
        }

        .allpopup-btns {
          margin-bottom: 21px;
          button.submit-btn.btn.btn-primary.approval-btn {
            justify-content: center !important;
            background: #103f5e !important;
            border-radius: 16.6275px;
            width: 111px;
            height: 33px;
            margin-inline-end: 15px;
            display: flex;
            align-items: center;
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff;
          }
          button.submit-btn.btn.btn-primary.approval-btn:disabled {
            opacity: 0.4 !important;
            cursor: not-allowed;
          }

          button.btn.btn-outline-danger.cancellation-btn {
            margin-inline-start: 15px !important;
            width: 111px;
            height: 33px;
            border: 1.5px solid #f46a6a !important;
            border-radius: 16.6275px !important;
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.selected-location.d-flex {
  width: 416px;
  height: 55px;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  background: #f2f2f2;
  padding-inline-start: 20px;
  padding-inline-end: 17px;
  margin-top: 16px;
  .lcation-label {
    font-weight: 700;
    font-size: 12px;
    margin-top: -7px;
    margin-bottom: 3px;
    color: #103f5e;
    line-height: 17px;
  }
  .selected-map-location {
    font-size: 16px;
    font-weight: 700;
    line-height: 17px;
    width: 320px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #4a4a4a;
  }
}
.geo-text {
  font-weight: 600;
  font-size: 16px;
  line-height: 17px;
  color: #787878;
  margin-inline-end: 8px;
  margin-bottom: 0px !important;
}

.outer-div {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 416px;
  background: #f2f2f2;
  height: 55px;
  padding-inline-end: 17px;
  padding-inline-start: 20px;
  border-radius: 4px;
  .location-text {
    color: #4a4a4a;
    font-size: 16px;

    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    word-wrap: break-word;
  }
}
</style>
